module.exports = __webpack_public_path__ + "static/media/H&R-Block-Outlook-on-American-Life-2023.a3553ee0.pdf";